var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.title)?_c('div',{staticClass:"hd-view"},[_c('div',{staticClass:"back-btn"},[_c('div',{on:{"click":_vm.back}},[(_vm.backShow)?_c('img',{staticClass:"back-img",attrs:{"src":require("../../assets/images/IndexImages/angle-left.svg")}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.title)}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5536cc8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/navHeader.vue
// module id = null
// module chunks = 